<script>
    let sending = false;
    let message = "";
    let status = ""; // 'success' | 'error'

    async function handleSubmit(event) {
        event.preventDefault();

        const formData = new FormData(event.target);
        sending = true;
        try {
            const res = await fetch("/api/drop", {
                method: "POST",
                body: formData,
            });

            const data = await res.json();

            if (res.ok) {
                showMessage(data.message || "Success!", "success");
                event.target.reset();
            } else {
                showMessage(data.message || "Something went wrong.", "error");
            }
        } catch (err) {
            showMessage("Network error.", "error");
        }
    }

    function showMessage(text, type) {
        message = text;
        status = type;
        sending = false;

        // Destroy after 10 seconds
        setTimeout(() => {
            message = "";
            status = "";
        }, 10_000);
    }
</script>

{#if message}
    <div
        class="
               p-2
               {status === 'success'
            ? 'border-2 border-green-400  text-primary-content'
            : ''}
               {status === 'error'
            ? 'border-2 border-red-400  text-primary-content'
            : ''}
               "
    >
        {message}
    </div>
{:else}
    <p>
        Εάν θες να μοιραστείς κάποιο στοιχείο για συνωμοσία ή άλλο μυστήριο θέμα
        στείλε το μήνυμα σου παρακάτω.
    </p>

    <p>
        Για μεγαλύτερη ανωνυμία χρησιμοποίησε <a
            class="underline"
            href="https://www.torproject.org/download/">Tor Browser.</a
        >
    </p>
{/if}

<form
    on:submit={handleSubmit}
    class="m-auto opacity-70 grid grid-cols-4 gap-1 mb-4 mt-4"
>
    <input
        class="col-span-3 p-1 bg-neutral shadow-md shadow-black text-primary-content border-2 border-primary-neutral focus:border-fuchsia-400"
        name="name"
        type="text"
        placeholder="όνομα (προαιρετικό)"
    />
    <button
        class="btn bg-primary-content text-primary shadow-md shadow-black"
        type="submit"
    >
        {#if sending}
            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                style="margin: auto; background: rgb(255, 255, 255); display: block; shape-rendering: auto;"
                width="24px"
                height="24px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
            >
                <path
                    fill="none"
                    stroke="#d946ef"
                    stroke-width="8"
                    stroke-dasharray="177.0463604736328 79.54256774902345"
                    d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
                    stroke-linecap="round"
                    style="transform:scale(1);transform-origin:50px 50px"
                >
                    <animate
                        attributeName="stroke-dashoffset"
                        repeatCount="indefinite"
                        dur="1s"
                        keyTimes="0;1"
                        values="0;256.58892822265625"
                    />
                </path>
            </svg>
        {:else}
            Post
        {/if}
    </button>
    <textarea
        class="col-span-4 p-1 bg-neutral shadow-md shadow-black text-primary-content border-2 border-primary-neutral focus:border-fuchsia-400"
        name="comment"
        placeholder="σχόλιο"
        cols="40"
        rows="10"
    />
</form>

<style>
    textarea,
    input,
    button {
        outline: none;
    }
</style>
